export default __webpack_public_path__ + "static/media/card-diet-icon.242ae770.svg";